import { Button, ButtonVariants } from '@components/button/Button';
import { Modal } from '@components/modal/Modal';
import { ModalActions } from '@components/modal/ModalActions';

export interface UndoCheckInGuestConfirmationModalProps {
  closeModal: () => void;
  isOpen: boolean;
  onUndoCheckInGuest: () => void;
}

export const UndoCheckInGuestConfirmationModal = ({
  closeModal,
  isOpen,
  onUndoCheckInGuest,
}: UndoCheckInGuestConfirmationModalProps) => {
  const handleUndoCheckInGuest = (): void => {
    closeModal();
    onUndoCheckInGuest();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={closeModal}
      title="Undo Check-in?"
      subtitle="Undoing the check-in will remove this guest's admitted status, allowing you to
          check them in again if needed. This is different from marking a
          guest as finished in which their event experience is complete."
    >
      <ModalActions>
        <Button
          label="Keep Guest Checked In"
          onClick={closeModal}
          variant={ButtonVariants.Tertiary}
        />
        <Button
          label="Undo Check-in"
          onClick={handleUndoCheckInGuest}
          variant={ButtonVariants.Primary}
        />
      </ModalActions>
    </Modal>
  );
};
